<template>
  <div class="page-wrapper">
    <div class="page-content--bge5">
      <div class="container">
        <div class="login-wrap">
          <div class="login-content">
            <div class="login-logo">
              <img src="@/assets/images/logo.jpg" alt="CoolAdmin">
            </div>
            <div class="login-form">
              <form @submit.prevent="onSubmit">
                <div class="form-group">
                  <label>Email Address</label>
                  <input
                    class="au-input au-input--full"
                    type="email"
                    name="email"
                    placeholder="Email"
                    v-on:input="onChangeHandler('email', $v.email)"
                    :class="{ 'form-control is-invalid': $v.email.$error }"
                    v-model="email"
                  >
                  <div class="invalid-feedback">{{ this.getErrorMsg('email')[0] }}</div>
                </div>
                <div class="form-group">
                  <label>Password</label>
                  <input
                    class="au-input au-input--full"
                    type="password"
                    name="password"
                    placeholder="Password"
                    v-on:input="onChangeHandler('password', $v.password)"
                    :class="{ 'form-control is-invalid': $v.password.$error }"
                    v-model="password"
                  >
                  <div class="invalid-feedback">{{ this.getErrorMsg('password')[0] }}</div>
                </div>
                <button class="au-btn au-btn--block au-btn--green m-b-20" type="submit">Нэвтрэх</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdminService from "@/services/AdminService";
import Form from "@/mixins/Form.js";

export default {
  name: "SignIn",

  mixins: [Form],

  created() {
    if (this.$store.getters.loggedAdmin !== null) this.$router.push("/");
  },

  data() {
    return {
      email: "",
      password: ""
    };
  },

  validations: {
    email: {
      serverFailed: function() {
        return !this.hasServerError("email");
      }
    },
    password: {
      serverFailed: function() {
        return !this.hasServerError("password");
      }
    }
  },

  methods: {
    serverRequest: AdminService.login,

    successHandler(response) {
      localStorage.setItem("token", response.headers.my_token);
      this.$store.dispatch("setAdmin", response.data.payload);
      this.$router.push("/");
    },

    createJsonData() {
      const data = JSON.parse("{}");
      data.email = this.email;
      data.password = this.password;
      return data;
    }
  }
};
</script>